import { render, staticRenderFns } from "./CardRecentTransactions.vue?vue&type=template&id=c1bea630&scoped=true&"
import script from "./CardRecentTransactions.vue?vue&type=script&lang=js&"
export * from "./CardRecentTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1bea630",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c1bea630')) {
      api.createRecord('c1bea630', component.options)
    } else {
      api.reload('c1bea630', component.options)
    }
    module.hot.accept("./CardRecentTransactions.vue?vue&type=template&id=c1bea630&scoped=true&", function () {
      api.rerender('c1bea630', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/accountdashboard/CardRecentTransactions.vue"
export default component.exports